import { LabeledInput } from "@/Components/Form";
import { FormError } from "@/Components";
import React, { useState } from "react";
import { Inertia } from "@inertiajs/inertia";

export default function SettingsBilling({ organization, errors }) {
  let [dirty, setDirty] = useState(false);

  let [values, setValues] = useState({
    billing_method: organization.data.billing.method || "email",
    billing_email: organization.data.billing.email || "",
    billing_country: organization.data.billing.country || "",
    billing_address: organization.data.billing.address || "",
    billing_city: organization.data.billing.city || "",
    billing_zipcode: organization.data.billing.zipcode || "",
    vat_number: organization.data.vat_number || "",
  });

  function isSaveDisabled() {
    if (values.billing_method === "email") {
      return !(values.billing_email && values.billing_country) || !dirty;
    } else {
      return (
        !(
          values.billing_address &&
          values.billing_city &&
          values.billing_zipcode
        ) || !dirty
      );
    }
  }

  function handleUpdate(event) {
    setDirty(true);
    setValues((prevValues) => {
      return { ...prevValues, [event.target.name]: event.target.value };
    });
  }

  function handleSave(e) {
    e.preventDefault();

    if (isSaveDisabled()) {
      return;
    }

    Inertia.put(`/company-settings/${organization.data.id}/billing`, values, {
      onSuccess: () => {
        setDirty(false);
      },
    });
  }

  function SettingsSaveButton() {
    let disabled = false;

    if (isSaveDisabled()) {
      disabled = true;
    }

    return (
      <button
        disabled={disabled}
        className="btn-blue ml-auto max-w-fit self-end"
      >
        Save changes
      </button>
    );
  }

  return (
    <div className="shadow-small mb-6 bg-gray-light p-8">
      <form onSubmit={handleSave} key={organization.data.id}>
        <div className="flex flex-row flex-wrap justify-between">
          <div className="mb-4 w-full">
            <label className="mr-4">
              <input
                checked={values.billing_method === "email"}
                value={"email"}
                type="radio"
                name="billing_method"
                onChange={handleUpdate}
              />
              <span className="ml-2">Billing by e-mail</span>
            </label>

            <label className="mr-4">
              <input
                checked={values.billing_method === "postal"}
                value={"postal"}
                type="radio"
                name="billing_method"
                onChange={handleUpdate}
              />
              <span className="ml-2">
                Billing by snail-mail (0,54 gram CO₂e per bill)
              </span>
            </label>
            <FormError error={errors.billing_method} />
          </div>

          {values.billing_method === "email" && (
            <>
              <div className="mb-4 w-full">
                <LabeledInput
                  title="E-mail*"
                  placeholder="Enter e-mail"
                  name="billing_email"
                  required="required"
                  type="email"
                  value={values.billing_email}
                  onChange={handleUpdate}
                  error={errors.billing_email}
                />
              </div>

              <div className="mb-4 w-full">
                <LabeledInput
                  title="Country*"
                  placeholder="Enter country"
                  name="billing_country"
                  required="required"
                  value={values.billing_country}
                  onChange={handleUpdate}
                  error={errors.billing_country}
                />
              </div>
            </>
          )}

          {values.billing_method === "postal" && (
            <>
              <div className="mb-4 w-full">
                <LabeledInput
                  title="Billing address*"
                  placeholder="Enter billing address"
                  name="billing_address"
                  required="required"
                  value={values.billing_address}
                  onChange={handleUpdate}
                  error={errors.billing_address}
                />
              </div>

              <div className="mb-4 w-full md:w-1/2">
                <LabeledInput
                  title="ZIP-code*"
                  placeholder="Enter ZIP-code"
                  name="billing_zipcode"
                  required="required"
                  value={values.billing_zipcode}
                  onChange={handleUpdate}
                  error={errors.billing_zipcode}
                />
              </div>

              <div className="mb-4 w-full md:w-1/2 md:pl-4">
                <LabeledInput
                  title="City*"
                  placeholder="Enter city"
                  name="billing_city"
                  required="required"
                  value={values.billing_city}
                  onChange={handleUpdate}
                  error={errors.billing_city}
                />
              </div>
            </>
          )}

          <div className="mb-4 w-full">
            <LabeledInput
              title="VAT-number"
              placeholder="Enter VAT"
              name="vat_number"
              value={values.vat_number}
              onChange={handleUpdate}
              error={errors.vat_number}
            />
          </div>

          <SettingsSaveButton />
        </div>
      </form>
    </div>
  );
}
